import type { Event } from '@patsnap/tahiti-core';
import type { FtoTaskStep } from '../enums';
import type { FtoReportTaskStatus } from '../types';

/**
 * 获取任务状态服务
 * @description 获取任务状态, 并更新任务状态模型 {@link FtoReportTaskStatusModel}
 */
export interface FtoReportTaskStatusService {
    /**
     * 服务端任务步骤
     */
    readonly serverSideTaskStep: FtoTaskStep;
    /**
     * 服务端任务步骤事件
     */
    readonly onServerSideTaskStep: Event<FtoTaskStep>;
    /**
     * 获取任务状态, 并更新任务状态模型 {@link FtoReportTaskStatusModel}
     */
    pullTaskStatus(): Promise<FtoReportTaskStatus>;
}

export const FtoReportTaskStatusService = Symbol('FtoReportTaskStatusService');
